const styles = () => ({
  root: {
    padding: '20px 0',
  },
  content: {
    display: 'flex',
  },
  label: {
    width: '100px',
  },
  body: {
    fontWeight: '500',
  },
});

export default styles;
